import React, { useEffect, useState } from "react";
import "./Slider.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Slider = () => {

    const slides = [
        {
            id: 0,
            title: "الواجهة ثلاثية الأبعاد",
            img_src: "assets/3d/0.jpg",
        },
        {
            id: 1,
            title: "الواجهة الجنوبية",
            img_src: "assets/3d/1.jpg",
        },
        {
            id: 2,
            title: "الواجهة الجنوبية",
            img_src: "assets/3d/2.jpg",
        },
        {
            id: 3,
            title: "الواجهة الشرقية",
            img_src: "assets/3d/3.jpg",
        },
        {
            id: 4,
            title: "الواجهة الشرقية",
            img_src: "assets/3d/4.jpg",
        },
        {
            id: 5,
            title: "الواجهة الشمالية",
            img_src: "assets/3d/5.jpg",
        },
        {
            id: 6,
            title: "الواجهة الشمالية",
            img_src: "assets/3d/6.jpg",
        },
        {
            id: 7,
            title: "الواجهة الغربية",
            img_src: "assets/3d/7.jpg",
        },
        {
            id: 8,
            title: "الواجهة الغربية",
            img_src: "assets/3d/8.jpg",
        }
    ];

    const [index, setIndex] = useState(0);

    const nextSlide = () => {
        setIndex((prevIndex) => (prevIndex + 1) % slides.length);
    };

    const prevSlide = () => {
        setIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
    };

    const prev = (index - 1 + slides.length) % slides.length;
    const current = index;
    const next = (index + 1) % slides.length;



    useEffect(() => {
        Fancybox.bind('[data-fancybox="gallery"]', {});
    
        return () => {
            Fancybox.destroy();
        };
    }, []);
    


    return (
        <div className="slider-container" id='details' >
            <div className="sliders">
                
                <div className="slide slide-3" >
                    <img src={slides[next].img_src} alt={slides[next].title} />
                    <div className="title_cot2">
                        <h2>{slides[prev].title}</h2>
                    </div>
                </div>

                <a href={slides[current].img_src} data-fancybox="gallery" data-caption={slides[current].title}>
                    <div className="slide slide-2">
                        <img src={slides[current].img_src} alt={slides[current].title} />
                        <div className="text">
                            <h2>{slides[current].title}</h2>
                        </div>
                    </div>
                </a>


                <div className="slide slide-1">
                    <img src={slides[prev].img_src} alt={slides[prev].title} />
                    <div className="title_cot1">
                        <h2>{slides[prev].title}</h2>
                    </div>
                </div>

            </div>
            <div className="controls">
                <button onClick={prevSlide} ><img src="arrow.png" alt="arrow" className="arrow_right" /></button>
                <button onClick={nextSlide}><img src="arrow.png" alt="arrow" className="arrow_left" /></button>
            </div>
        </div>
    );
};

export default Slider;
